import { CheckCircle2, Package, TriangleAlert, XCircle } from 'lucide-react';
import { cn } from '@/utils/cn';
import type { InventoryStatus } from '../types/inventoryList.types';

const statusConfig: Record<InventoryStatus, { label: string; className: string; Icon: typeof CheckCircle2 }> = {
 in_stock: { label: 'Đang sử dụng', className: 'bg-emerald-50 text-emerald-600', Icon: CheckCircle2 },
 low_stock: { label: 'Sắp hết hàng', className: 'bg-orange-50 text-orange-600', Icon: TriangleAlert },
 out_of_stock: { label: 'Hết hàng', className: 'bg-red-50 text-red-700', Icon: Package },
 inactive: { label: 'Ngừng sử dụng', className: 'bg-slate-100 text-slate-600', Icon: XCircle },
};

export function inventoryStatusLabel(status: InventoryStatus) {
 return statusConfig[status]?.label ?? status;
}

export function InventoryStatusBadge({ status, className = '' }: { status: InventoryStatus; className?: string }) {
 const config = statusConfig[status] ?? statusConfig.in_stock;
 return (
 <span className={cn('inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs ', config.className, className)}>
 {config.label}
 </span>
 );
}

